import { ResponsiveMedia } from '../ResponsiveMedia';

type ImpactVideoProps = Readonly<{
	video: string;
	title: string;
	view: 'mobile' | 'desktop';
}>;

export const ImpactVideo: React.FC<ImpactVideoProps> = ({ video, title, view }) => {
	return (
		<ResponsiveMedia view={view} kind="video">
			<div className="aspect-video w-full">
				<iframe
					className="md:rounded-large h-full w-full rounded-none"
					data-testid="impact-story-video"
					src={video}
					title={title}
					aria-label={title}
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					referrerPolicy="strict-origin-when-cross-origin"
					allowFullScreen
				/>
			</div>
		</ResponsiveMedia>
	);
};
